import { SchemaView } from '../components'

import type {
  PluginVisitors,
  RehajePlugin,
  RehajePluginConstructor,
  TypedNodeConstructor,
  ViewModelConstructor
} from '@rehaje/core'

/**
 * 创建 Schema 表单插件
 * @param type
 * @param model
 * @param node
 * @returns
 */
export const createSchemaPlugin = <
  Node extends TypedNodeConstructor,
  Model extends ViewModelConstructor
>(
  type: string,
  model: Model,
  node: Node
): RehajePluginConstructor => {
  return class SchemaPlugin implements RehajePlugin {
    visitors: PluginVisitors = {
      components: {
        [type]: SchemaView
      },
      models: {
        [type]: model
      },
      nodes: {
        [type]: node
      }
    }
  }
}
